/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getAuditTrail } from "api/services/quoteRequest";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

type GetAuditTrailOptions = {
  shipmentId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetAuditTrail = (data: GetAuditTrailOptions) =>
  useQuery<any>({
    queryKey: quoteRequestQueryKeys.quoteAuditTrailListing(data.shipmentId),
    queryFn: data.queryFn ? data.queryFn : () => getAuditTrail(data.shipmentId).then((res) => res.data),
    ...data.options,
  });
